import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { IUserTicketData } from 'meta/pages/v4/ticket'
import { IWalletEntityType, IWalletEvent } from 'meta/pages/v4/wallet'
import { Dates } from 'utils/dates'

type V4Props = {
  userTicketData: IUserTicketData
  walletEventData: IWalletEvent
}

export const useV4TicketStatus = (props: V4Props) => {
  const { userTicketData, walletEventData } = props
  const { t } = useTranslation()

  const getStatusByDate = useCallback(
    (date: string): string => {
      const validityDate = new Date(date)
      const validityDay = Dates.format(validityDate, t('dates:wallet:date'))
      const validityHours = Dates.format(validityDate, t('dates:common:hoursMinutes'))

      if (userTicketData.seasonData && userTicketData.seasonData.events.length > 0) {
        return userTicketData.status?.label
      }

      return t(
        `wallet:ticket_${walletEventData.type == IWalletEntityType.good_service ? 'goods' : userTicketData.seasonData ? 'season' : 'single'}_${userTicketData.status?.key.toLowerCase()}`,
        {
          time: validityHours,
          date: validityDay,
        }
      )
    },
    [t, userTicketData.seasonData, userTicketData.status]
  )

  return useMemo<string>(() => {
    if (userTicketData.status?.key === 'VALID' && userTicketData?.validityDate?.date_tz) {
      return getStatusByDate(userTicketData?.validityDate?.date_tz)
    }
    if (userTicketData.status?.key === 'CHECKED' && userTicketData?.events[0]?.entryDateTime?.date_tz) {
      return getStatusByDate(userTicketData?.events[0]?.entryDateTime?.date_tz)
    }
    return userTicketData.status?.label
  }, [
    getStatusByDate,
    userTicketData?.events[0]?.entryDateTime?.date_tz,
    userTicketData.status?.key,
    userTicketData.status?.label,
    userTicketData?.validityDate?.date_tz,
  ])
}
